import { ApplicationConfig, inject, provideZoneChangeDetection } from '@angular/core';
import { NavigationError, Router, provideRouter, withNavigationErrorHandler } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatSnackBar } from '@angular/material/snack-bar';

import { routes } from './app.routes';
import { AuthInterceptor } from './interceptors/auth.interceptor';

const chunkLoadReloadFlag = 'iflyfinance:chunk-load-reload';

function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  return /Failed to fetch dynamically imported module|Loading chunk [^ ]+ failed/i.test(error.message);
}

function reloadAfterChunkLoad(error: NavigationError): void {
  if (!isChunkLoadError(error.error)) {
    throw error.error;
  }

  const router = inject(Router);
  const snackBar = inject(MatSnackBar);
  const hasReloaded = sessionStorage.getItem(chunkLoadReloadFlag) === 'true';

  if (hasReloaded) {
    sessionStorage.removeItem(chunkLoadReloadFlag);
    throw error.error;
  }

  sessionStorage.setItem(chunkLoadReloadFlag, 'true');
  snackBar.open('A new version is available. Reloading...', undefined, {
    duration: 2000,
    horizontalPosition: 'center',
    verticalPosition: 'top',
    panelClass: ['success-snackbar']
  });

  window.setTimeout(() => {
    window.location.assign(router.url || error.url);
  }, 500);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withNavigationErrorHandler(reloadAfterChunkLoad)),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideAnimations()
  ]
};
